module.exports = __webpack_public_path__ + "static/media/iwin-2.6b442cd9.jpg";